export default "__VITE_ASSET__DS99Glv4__"